<template>
    <div class="table-wrapper cover-content project-list">
        <!-- <high-search>  -->
            <Form ref="formInline" :model="formInline" inline class="form-list"
                  :label-width="100" label-position="right">
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="项目名称:" prop="projectName" :label-width="78">
                            <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="建设单位:" prop="buildCorpName">
                            <Input v-model="formInline.buildCorpName" placeholder="请输入建设单位"></Input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="实名制情况:" prop="regState">
                            <RadioGroup v-model="formInline.regState">
                                <Radio :label="-1">全部</Radio>
                                <Radio :label="1">已上传实名数据</Radio>
                                <Radio :label="0">未上传实名数据</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="4" class="high-search">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>
                    <Col span="6">
                        <FormItem label="项目状态:" prop="prjStatus" :label-width="78">
                            <Select v-model="formInline.prjStatus" clearable placeholder="请选择项目状态">
                                <Option v-for="(item,index) in projectStatus" :value="item.code" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="项目分类：" prop="category">
                            <Select v-model="formInline.category" clearable placeholder="请选择项目分类">
                                <Option v-for="(item,index) in projectCatetory" :value="item.code" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="施工单位：" prop="winUnit">
                            <Input v-model="formInline.winUnit" placeholder="请输入施工单位"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="开工时间：" prop="WorkTime">
                            <DatePicker type="daterange" split-panels placeholder="请选择开始结束时间" :value="formInline.WorkTime" @on-change="formInline.WorkTime=$event" transfer></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>
                    <Col span="6">
                        <FormItem label="项目所在地:" :label-width="78">
                            <place-select v-model="formInline.areaCode"></place-select>
                            <!--<Select v-model="areaCode">-->
                                <!--<Option v-for="item in area" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
                            <!--</Select>-->
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="施工许可证办理情况：" prop="buildNumFlag">
                            <Select v-model="formInline.buildNumFlag" clearable placeholder="请选择项目分类">
                                <Option :value="0">全部</Option>
                                <Option :value="1">已办理施工许可证</Option>
                                <Option :value="2">正在办理施工许可证</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="开工报告办理情况：" prop="startReportFlag">
                            <Select v-model="formInline.startReportFlag" clearable placeholder="请选择项目分类">
                                <Option :value="0">全部</Option>
                                <Option :value="1">已办理开工报告</Option>
                                <Option :value="2">正在办理开工报告</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="施工许可证号：" prop="builderLicenseNum">
                            <Input v-model="formInline.builderLicenseNum" placeholder="请输入施工许可证号"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <Button :loading="eLoading" style="margin-bottom:24px;" type="primary" icon="ios-exit-outline" @click="handleExport">导出</Button>
                    </Col>
                </Row>
            </Form>
        <!-- </high-search> -->
        <ul style="border:none;position: relative;flex-wrap: wrap;display: flex;">
            <Spin fix v-if="loading"></Spin>
            <li class="list-no-data" v-if="tableData&&tableData.length===0">暂无数据</li>
            <li class="table-item" v-for="(item,index) in tableData" :key="index">
                <div class="table-item-title">{{item.projectName}}
                    <div style="margin-left:auto;">
 <Button class="table-item-btn" type="primary" ghost @click="handleDeal('projectDetail',item.projectId)">查看详情</Button>
                    </div>
                </div>
                <div class="table-item-main ajFlex">
                    <div class="aFlex" style="width: 100%">
                        <img style="height: 64px;width:64px;" src="../../../assets/table-list1.png" alt="">
                        <div class="table-item-txt">
                            <div>
                                <span class="table-item-label">开工时间：</span>
                                <span>{{item.startDate}}</span>
                            </div>
                            <div style="margin-top:8px;">
                                <span class="table-item-label">计划竣工时间：</span>
                                <span>{{item.completeDate}}</span>
                            </div>
                            <div style="margin-top:8px;">
                                <span class="table-item-label">建设单位：</span>
                                <span>{{item.buildCorpName}}</span>
                            </div>
                            <div style="margin-top:8px;">
                                <span class="table-item-label">施工单位：</span>
                                <span>{{item.contractorCorpName}}</span>
                            </div>
                            <div class="table-item-tr">
                                <Dropdown v-if="item.builderLicenseNum && item.builderLicenseNumArr && item.builderLicenseNumArr.length"
                                          trigger="click" @on-visible-change="v => visibleChange(v, index)"
                                >
                                    <div href="javascript:void(0)" class="visible-handle">
                                        <span>{{ item.builderLicenseNumArr[0] }}</span>
                                        <span v-if="item.builderLicenseNumArr.length > 1">
                                        <!--<span>-->
                                            <Icon size="16" v-show="item.visible" type="ios-arrow-up"></Icon>
                                            <Icon size="16" v-show="!item.visible" type="ios-arrow-down"></Icon>
                                        </span>
                                    </div>
                                    <template #list v-if="item.builderLicenseNumArr.length > 1">
                                    <!--<template #list >-->
                                        <DropdownMenu style="padding: 5px 0">
                                            <div v-for="(t,i) in item.builderLicenseNumArr" :key="i">
                                                <DropdownItem v-if="i > 0"> {{ t }}</DropdownItem>
                                                <!--<DropdownItem> {{ t }}</DropdownItem>-->
                                            </div>
                                        </DropdownMenu>
                                    </template>
                                </Dropdown>
                                <div v-else>
                                    <div class="ft-r-t">
                                        <div v-if="item.buildNumFlag == 1" class="ft-green-bg">已办理施工许可证</div>
                                        <div v-else class="ft-red-bg">正在办理施工许可证</div>
                                    </div>
                                    <div class="ft-r-t">
                                        <div v-if="item.buildNumFlag != 1 && item.startReportFlag == 1" class="ft-green-bg">已办理开工报告</div>
                                        <div v-if='item.buildNumFlag != 1 && item.startReportFlag != 1' class="ft-red-bg">正在办理开工报告</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul class="table-item-bottom aFlex">
                    <li class="table-item-list">
                        <div class="table-list-bold">{{item.prjStatus}}</div>
                        <span class="table-list-gray">项目状态</span>
                    </li>
                    <li class="table-item-list">
                        <div class="table-list-bold">{{item.areaName}}</div>
                        <span class="table-list-gray">行政区划</span>
                    </li>
                    <li class="table-item-list">
                        <div class="table-list-bold">{{item.category}}</div>
                        <span class="table-list-gray">项目分类</span>
                    </li>
                    <li class="table-item-list" >
                        <div v-if="item.regState == '已上传实名数据'" class="table-list-bold ft-green ft-r-b" >{{item.regState}}</div>
                        <div v-else class="table-list-bold ft-red ft-r-b">{{item.regState}}</div>
                        <span class="table-list-gray">实名制情况</span>
                    </li>
                    <!-- <li class="table-item-list">
                        <span class="table-list-gray">施工许可证办理情况</span>
                        <div v-if="item.buildNumFlag == 1" class="table-list-bold ft-green">已办理施工许可证</div>
                        <div v-else class="table-list-bold ft-red">正在办理徐工许可证</div>
                    </li>
                    <li class="table-item-list">
                        <span class="table-list-gray">开工报告办理情况</span>
                        <div v-if="item.startReportFlag == 1" class="table-list-bold ft-green">已办理开工报告</div>
                        <div v-else class="table-list-bold ft-red">正在办理开工报告</div>
                    </li> -->
                </ul>
            </li>
        </ul>
        <div class="t-page">
            <Page :total="totalCount" :page-size="pageSize" :current="page"
                  @on-change="changePage" @on-page-size-change="pageSizeChange"
                  show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<style scoped lang="less">

    .table-item{
        position: relative;
        width: calc(50% - 8px);
        margin-bottom: 16px;
        border: 1px solid #D7DDE4;
    }
    .table-item:nth-of-type(2n-1) {
        margin-right: 16px;
    }
    .table-item-title{
        height: 44px;
        background: #F5F7F9;
        border-bottom: 1px solid #D7DDE4;
        font-weight: 700;
        font-style: normal;
        font-size: 16px;
        text-align: left;
        display: flex;
        align-items: center;
        padding: 0 12px;
    }
    .table-item-btn{
         margin-left: auto;
        color: #3399FF;
        height: 28px;
    }
    .table-item-main{
        /* padding: 10px 15px 5px 25px; */
        padding: 8px;
        position: relative;
    }
    .table-item-txt{
        font-size: 14px;
        width: 100%;
    }
    .table-item-label{
        font-weight: 700;
        padding-left: 18px;
        line-height: 20px;
    }
    .table-item-bottom{
        padding: 8px;
        position: relative;
    }
    .table-item-bottom::before{
        content: '';
        position: absolute;
        left: 8px;
        right: 8px;
        top: 0;
        border-top: 1px dashed #E3E8EE;
    }
    .table-item-list{
        text-align: center;
        width: 25%;
        border-right: 1px dashed #E9E9E9;
        box-sizing: border-box;
    }
    .table-item-list:last-child{
        border-right:none;
        flex: 1;
    }
    .table-list-gray{
        font-size: 12px;
        color: #999999;
    }
    .table-list-bold{
        font-size: 15px;
        font-weight: 700;
        line-height: 32px;
        height: 32px;
    }
    .table-item-tr {
        position: absolute;
        top: 8px;
        right: 12px;
        .visible-handle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 8px;
            width: 175px;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            background: #E6F2FF;
            border-radius: 2px 2px 0px 0px;
            color: #3399FF;
        }
        /deep/.ivu-select-dropdown {
            margin: 0;
            padding: 0;
            width: 100%;
            box-shadow: 0px 2px 6px 0px rgba(51,153,255,0.2000);
            .ivu-dropdown-item {
                font-size: 12px !important;
                font-weight: 400;
                color: #3399FF;
                padding: 4px 8px;
            }
        }
    }
</style>
<script>
    import {mapState,mapGetters} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                open: false,
                formInline:{
                    areaCode: localStorage.getItem('tenantAreaCode'),
                    //项目名称：
                    projectName:'',
                    builderLicenseNum:'',
                    //项目分类：
                    category:'',
                    //施工单位：
                    winUnit:'',
                    //建设单位：
                    buildCorpName:'',
                    //项目状态：
                    prjStatus:'',
                    //开工开始时间:
                    startWorkTimeStart:'',
                    //开工结束时间：
                    startWorkTimeEnd:'',
                    //实名制状态：
                    regState: -1,
                    WorkTime:[],
                    //施工许可证办理情况 0全部1已办理2正在办理
                    buildNumFlag: 0,
                    startReportFlag: 0
                },
                tableData:[],
                exportData:{}
            };
        },
        computed:{
            ...mapState([ 'area']),
            ...mapGetters(['projectStatus','projectCatetory']),
        },
        created(){
            this.$route.query.areaCode && (this.formInline.areaCode = this.$route.query.areaCode)
            this.formInline.regState = this.$route.query.regState ? this.$route.query.regState : -1;
            this.formInline.prjStatus = this.$route.query.prjStatus ? this.$route.query.prjStatus : ''
        },
        mounted(){

        },
        watch: {
        },
        methods: {
            visibleChange(v, index) {
                // console.log(v)
                // console.log(index)
                this.$set(this.tableData[index], 'visible', v)
            },
            handleReset () {
                this.formInline = {
                    builderLicenseNum: '',
                    areaCode : localStorage.getItem('tenantAreaCode'),
                    //项目名称：
                    projectName:'',
                    //项目分类：
                    category:'',
                    //施工单位：
                    winUnit:'',
                    //建设单位：
                    buildCorpName:'',
                    //项目状态：
                    prjStatus:'',
                    //开工开始时间:
                    startWorkTimeStart:'',
                    //开工结束时间：
                    startWorkTimeEnd:'',
                    //实名制状态：
                    regState:-1,
                    WorkTime:[],
                    //施工许可证办理情况 0全部1已办理2正在办理
                    buildNumFlag: 0,
                    startReportFlag: 0
                }
                this.getTableData();
            },
            //导出
            handleExport(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                this.formInline.startWorkTimeStart=this.formInline.WorkTime[0];
                this.formInline.startWorkTimeEnd=this.formInline.WorkTime[1];
                Object.assign(param,this.formInline);
                delete param.WorkTime;
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/project/export',
                    responseType:'arraybuffer',
                    data: param,
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'项目数据.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name,projectId){
                this.$router.push({
                    name: name,
                    query: {
                        projectId:projectId
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                this.formInline.startWorkTimeStart=this.formInline.WorkTime[0];
                this.formInline.startWorkTimeEnd=this.formInline.WorkTime[1];
                Object.assign(param,this.formInline);
                delete param.WorkTime;
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/project/pageList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total;
                        const tableData=response.data.data.records;
                        tableData.forEach(t => {
                            if(t.builderLicenseNum) {
                                t.builderLicenseNumArr = t.builderLicenseNum.split(',')
                            }
                            t.visible = false;

                        });
                        this.tableData = tableData;
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
